import {captureSentryExceptionAndThrowLocal} from 'app/services/sentry/sentryLogging';

const processHydrationErrors = () => {
  const queue = window.hydrationErrorQueue;

  if (Array.isArray(queue)) {
    queue.forEach(({error, extra}) => {
      captureSentryExceptionAndThrowLocal(error, {extra});
    });
    window.hydrationErrorQueue = [];
    delete window.hydrationErrorQueue;
  }
};

export default processHydrationErrors;
